import _objectWithoutProperties from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DETOX-SHOP218-JOB1/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["title", "titleId"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import * as React from "react";

function Community(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M14.626 13.716c2.206 0 4 1.795 4 4v3.5h-2v-3.5a2 2 0 00-2-2H9.281c-1.103 0-2 .897-2 2v3.5h-2v-3.5c0-2.206 1.794-4 4-4h5.345zm-9.578-.552a1 1 0 010 2H4c-.552 0-1 .45-1 1v3.127a1 1 0 01-2 0v-3.127c0-1.654 1.346-3 3-3h1.048zm14.89 0c1.655 0 3 1.346 3 3v3.127a1 1 0 11-2 0v-3.127c0-.55-.447-1-1-1h-1.047a1 1 0 010-2h1.048zM4.206 5.914a3.052 3.052 0 013.048 3.05 3.052 3.052 0 01-3.048 3.047 3.052 3.052 0 01-3.049-3.048 3.052 3.052 0 013.05-3.049zm15.497 0a3.053 3.053 0 013.05 3.05 3.053 3.053 0 01-3.05 3.047 3.053 3.053 0 01-3.049-3.048 3.053 3.053 0 013.05-3.049zM11.953 3a4.187 4.187 0 014.183 4.183 4.187 4.187 0 01-4.183 4.182A4.188 4.188 0 017.77 7.183 4.188 4.188 0 0111.953 3zM4.205 7.914a1.05 1.05 0 00-1.049 1.05 1.049 1.049 0 101.049-1.049zm15.497 0a1.05 1.05 0 00-1.049 1.05 1.05 1.05 0 002.098 0 1.05 1.05 0 00-1.049-1.05zM11.953 5A2.186 2.186 0 009.77 7.183c0 1.203.98 2.182 2.183 2.182a2.185 2.185 0 002.183-2.182A2.185 2.185 0 0011.953 5z",
    fill: props.color || "#222",
    fillRule: "evenodd"
  }));
}

var MemoCommunity = React.memo(Community);
export default MemoCommunity;